module.exports = __webpack_public_path__ + "img/people.7d7bb776.svg";